import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HolidaysRoutingModule } from './holidays-routing.module';
import { HolidaysDetailsComponent } from './components/holidays-details/holidays-details.component';
import { HolidaysViewComponent } from './components/holidays-view/holidays-view.component';
import { HolidaysComponent } from './holidays.component'
import { SharedModule } from 'src/app/shared/shared.module';
import { HolidayCreateComponent } from './components/holiday-create/holiday-create.component';


@NgModule({
  declarations: [HolidaysDetailsComponent, HolidaysViewComponent, HolidaysComponent, HolidayCreateComponent],
  imports: [
    CommonModule,
    HolidaysRoutingModule,
    SharedModule
  ]
})
export class HolidaysModule { }
